<simple-notifications></simple-notifications> <router-outlet></router-outlet>

<app-perf-hud></app-perf-hud>
